<template>
    <div class="auditResult">
        <Header ref="header" :title="title" @backPage="onBack"></Header>
        <div class="body">
            <div>
                <img :src="url" alt="">
                <div class="result">{{result}}</div>
                <span class="tips">请稍后去我的钱包查询充值结果</span>
            </div>
            <button @click="clickHandle">{{status === '40' ? '重新支付' : '查看结果'}}</button>
        </div>
    </div>
</template>

<script>
import Header from '../../../common/header'
export default {
    name: 'auditResult',
    data () {
        return {
            status: parseInt(this.$route.query.status) || 20,
            title: '充值结果',
            result: '充值成功',
            successUrl: require('../../../../assets/img/b2b/img_right@2x.png'),
            peddingUrl: require('../../../../assets/img/b2b/img_wait2.png'),
            failUrl: require('../../../../assets/img/b2b/img_wrong.png'),
            url: ''
        }
    },
    components: {
        Header
    },
    methods: {
        onBack () {
            this.$router.go(-1)
        },
        clickHandle () {
            this.$router.go(-1)
        }
    },
    mounted () {
        switch (this.status) {
            case 20:
                this.result = '充值处理中'
                this.url = this.peddingUrl
                break
            case 30:
                this.result = '充值成功'
                this.url = this.successUrl
                break
            case 40:
                this.result = '充值失败'
                this.url = this.failUrl
                break
            default:
                this.result = '系统异常'
        }
    }
}
</script>

<style lang="scss" scoped>
.auditResult {
    height: 100%;
    background-color: #fff;
}
.body {
    margin-top: 120px;
    text-align: center;
    img {
        width: 144px;
        height: 144px;
    }
    .result {
        color: #000000;
        font-size: 36px;
        font-weight: 400;
        margin: 48px 0 16px 0;
    }
    .tips {
        color: #8e8e93;
        font-size: 28px;
        font-weight: 400;
    }
    button {
        padding: 26px 200px;
        color: #ff7a45;
        border: 2px solid #ff7a45;
        border-radius: 40px;
        background-color: #fff;
        margin-top: 102px;
    }
}
</style>